import React from "react";
import "../styles.css";

export default function Title() {
    return (
        <div id="title-block">
            <p id="tb1">Deren Bozer</p>
            <p id="tb2">Frontend Developer</p>
            <p id="tb3">github.com/DerenB</p>
        </div>
    );
}